import { DomainCode } from '@australiangreens/ag-internal-components';
import { SearchFilter } from './searchFilterTypes';

export type SearchTreeNode = SearchTreeInternalNode | SearchTreeLeafNode;

// These are some extra, optional parameters we may want to use for the
// feature toggle.

export type ExtendedSearchTreeNode = SearchTreeNode & {
  printTime?: boolean;
  useAdvancedSearchII?: boolean;
};

// export type HashNode = (node: SearchTreeNode) => string;

type SetOperation = 'intersection' | 'union' | 'difference' | 'not';

export type SearchTreeInternalNode = {
  op: SetOperation;
  nodes: SearchTreeNode[];

  /** An ephemeral id unique within the tree used to keep track of an internal node.
   * Set from the query builder group id; used e.g. for delete-button handling.
   * Not meant to be sent to the backend. */
  _internalNodeId?: string;
};

// TODO: Do we even want this in the front end? Maybe if we add other contexts
// later? Its not like it could be abused in any way, the backend will always do
// an intersection against an all filter using the user's permissions
export type SearchFilterContext = {
  userPerm?: {
    domainCode: DomainCode;
    sub: string;
  };
};

export type SearchTreeLeafNode = {
  op: 'filter';
  filter: SearchFilter;
  filterContext?: SearchFilterContext;

  /** An ephemeral id unique within the tree used to keep track of a leaf node.
   * Motivation was for the SearchTemplatePage, but could be used for other
   * purposes. Importantly it is not meant to be sent to the backend.  */
  _leafNodeId?: string;
};

export function isSearchTreeLeafNode(node: SearchTreeNode): node is SearchTreeLeafNode {
  return node.op === 'filter' && 'filter' in node && 'name' in node.filter;
}
